<template>
  <el-form-item :label="item.label + colon" :class="{ alone: item.alone }">
    <template v-if="item.tooTip">
      <too-tip :item="item"></too-tip>
    </template>
    <div class="startend-box">
      <!-- eslint-disable vue/no-mutating-props -->
      <el-input
        class="startend-item"
        placeholder="请输入"
        type="text"
        :data-attr="item.key.split(',')[0]"
        :clearable="getValue(item, 'clearable', false)"
        :disabled="getValue(item, 'disabled', false)"
        :maxlength="11"
        @blur="telBlur($event, item, '1')"
        @keyup.native="telBlur($event, item)"
        v-model="formInline[item.key.split(',')[0]]"
      >
      </el-input>
      <!-- eslint-enable vue/no-mutating-props -->
      <div class="division">至</div>
      <!-- eslint-disable vue/no-mutating-props -->
      <el-input
        class="startend-item"
        placeholder="请输入"
        :data-attr="item.key.split(',')[1]"
        type="text"
        :clearable="getValue(item, 'clearable', false)"
        :disabled="getValue(item, 'disabled', false)"
        :maxlength="11"
        @blur="telBlur($event, item, '1')"
        @keyup.native="telBlur($event, item)"
        v-model="formInline[item.key.split(',')[1]]"
      >
      </el-input>
      <!-- eslint-enable vue/no-mutating-props -->
    </div>
  </el-form-item>
</template>

<script>
import TooTip from '../tooTip'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    formInline: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { TooTip },
  inject: {
    defaultMaxLenght: 'defaultMaxLenght',
    colon: 'colon',
    customTypeList: 'customTypeList',
    getValue: 'getValue',
    placeholder: 'placeholder',
    selectPlaceholder: 'selectPlaceholder',
    customInputHandle: 'customInputHandle',
    telBlur: 'telBlur',
    numberMax: 'numberMax',
    changeSelect: 'changeSelect',
  },
  data() {
    return {
    }
  },
  watch: {
  },
}
</script>


<style lang="scss" scoped>
// 起止组件样式
.startend-box {
  display: flex;
  width: 216px;
  justify-content: space-between;
  .startend-item {
    flex: 1;
  }
  .division {
    padding: 0 10px;
  }
}
</style>
